import OutlinedFieldFormik from './outlinedFieldFormik'
import React from 'react'
import FormatedInput from '../../common/fields/formatedInput'
const PostFieldFormik = (props: React.ComponentProps<typeof OutlinedFieldFormik>) => {
  return (
    <OutlinedFieldFormik
      placeholder='123456'
      InputProps={{
        inputComponent: FormatedInput as any,
      }}
      inputProps={{
        mask: '000000',
      }}
      {...props}
    />
  )
}

export default PostFieldFormik
